import React, { useEffect, useRef, useState } from "react";
// import { Link } from "react-router-dom";
import Select from "react-select";
import * as Chart from 'chart.js';
// import ReactApexChart from "react-apexcharts";

// import { S3Client, GetObjectCommand } from "@aws-sdk/client-s3";
// import { getSignedUrl } from "@aws-sdk/s3-request-presigner";
// import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION, AWS_BUCKET } from "../Global";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import { Apitoken, Authtoken, season_start, season_end } from "../Global";
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { MaterialReactTable } from 'material-react-table';
import PropTypes from 'prop-types';

import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { DateRangePicker } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';

const ProductionDashboard = () => {
  const [menu, setMenu] = useState(false);
  // const [cusomerbalance, setCusomerbalance] = useState([]);
  // const [dataacaliber, setDataacaliber] = useState([]);
  const [weeklyDataall, setWeeklyDataall] = useState([]);
  const [dataBoxes, setDataBoxes] = useState([]);
  const [productnameLists, setproductnameLists] = useState([]);
  const [dailyreports, setDailyreports] = useState([]);
  const [locationlist, setLocationlist] = useState([]);

  const [formData, setFormData] = useState({
    startDate: '',
    endDate: '',
    location: '',
    product: 1,
  });
  function getStartOfWeek(date) {
    const d = new Date(date);
    const day = d.getDay(); // Sunday = 0
    const diff = d.getDate() - day + (day === 0 ? -6 : 1); // adjust when day is Sunday
    return new Date(d.setDate(diff));
  }

  function getStartOfMonth(date) {
    return new Date(date.getFullYear(), date.getMonth(), 1);
  }

  function getEndOfMonth(date) {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
  }

  function getStartOfYear(date) {
    return new Date(date.getFullYear(), 0, 1);
  }
  function getEndOfYear(date) {
    return new Date(date.getFullYear(), 11, 31);
  }

  const now = new Date();

  const lastYearStart = new Date(now.getFullYear() - 1, 0, 1);
  const lastYearEnd = new Date(now.getFullYear() - 1, 11, 31);



  const season_start1 = new Date(season_start);
  const season_end1 = new Date(season_end);

  const predefinedRanges = [
    {
      label: 'This Week',
      value: [getStartOfWeek(now), now],
      closeOverlay: true
    },
    {
      label: 'This Month',
      value: [getStartOfMonth(now), getEndOfMonth(now)],
      closeOverlay: true
    },
    {
      label: 'This Year',
      value: [getStartOfYear(now), getEndOfYear(now)],
      closeOverlay: true
    },
    {
      label: 'Last Year',
      value: [lastYearStart, lastYearEnd],
      closeOverlay: true
    },
    {
      label: 'Current Season Range',
      value: [season_start1, season_end1],
      closeOverlay: true
    }
  ];
  const [value, setValue] = useState(predefinedRanges[4].value); // index 2 is "This Year"

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };


  // Fetch all dashboard data with payload { startDate, endDate, product }
  const fetchAllData = (range, product, location) => {
    const startDate = toLocalDateString(range[0]);
    const endDate = toLocalDateString(range[1]);
    //const payload = { startDate, endDate, product };
      const payload = { startDate, endDate, product, ...(location ? { location } : {}) };


    // Boxes
    axios.post("/production-dasboard/boxes", payload, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken } })
      .then(res => { if (res.data.code === 200) setDataBoxes(res.data.data); })
      .catch(console.log);
    // Boxes
    axios.post("/production-dasboard/daily-report", payload, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken } })
      .then(res => { if (res.data.code === 200) setDailyreports(res.data.data.daily_reports); })
      .catch(console.log);

    // // Daily reports
    // axios.post("/production-dasboard/calculate-daily-reports", payload, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken } })
    //   .then(res => { if (res.data.code === 200) setCusomerbalance(res.data.data.reports_groupby); })
    //   .catch(console.log);

    axios.post("/dashboard/daily-production-reports/listing-groupby-caliber-new2", payload, { headers: { Authorization: `Bearer ${Authtoken}`, Apitoken } })
      .then(res => {
        console.log("weekly123___");
        console.log(res.data.data.reports_groupby_calibres);
        setWeeklyDataall(res.data.data.reports_groupby_calibres);
      })
      .catch(console.log);
  };



  useEffect(() => {
    axios.get("/helpers/loading-locations", {
      headers: {
        Authorization: `Bearer ${Authtoken}`,
        Apitoken: Apitoken,
      },
    })
      .then((response) => {
        if (response.data.code === 200) {
          let locations = response.data.data.locations;

          let emp_statusList = locations.map((ord, index) => ({
            label: ord.title,
            value: ord.id,
            key: `sts-${index}`,
          }));

          setLocationlist(emp_statusList);

        }
      })
      .catch(console.log);
  }, []);
  useEffect(() => {


    axios.post(
      "/products/listing-groupby",
      {},
      {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      }
    )
      .then((response) => {
        if (response.data.code === 200) {
          let products = response.data.data.products;
          // setBarcodeProducts(products);
          console.log(products);
          let productslisting = products.map((customer, index) => ({
            label: customer.name,
            value: customer.id,
            key: `prodct-${index}`,
          }));
          setproductnameLists(productslisting);
          if (productslisting.length) {
            //const first = productslisting[0].value;
            setFormData(f => ({ ...f, product: 1 }));
            fetchAllData(value, 1);
          }

        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });



  }, []);


  // useEffect(() => {
  //   if (!formData.product) return;
  //   fetchAllData(value, formData.product);
  // }, [value, formData.product]);
  useEffect(() => {
  if (!formData.product) return;
  fetchAllData(value, formData.product, formData.location); // ✅
}, [value, formData.product, formData.location]); // ✅ location add

  const toLocalDateString = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const handleDateChange2 = (range) => {
    if (!Array.isArray(range) || range.length < 2) return;
    setValue(range);
  };



  const downloadpdf = () => {
    const input = document.getElementById('downloadpdf');

    html2canvas(input, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');

      const imgWidth = 210;
      const pageHeight = 297;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }
      const today = new Date();
      const formattedDate = today.toISOString().split('T')[0]; // YYYY-MM-DD
      const fileName = `Admin Dashboard ${formattedDate}.pdf`;
      pdf.save(fileName);
    });
  };
  const handleSelectChangeCustomer = (selectedOption) => {
    console.log(selectedOption);
    setFormData(f => ({ ...f, product: selectedOption.value }));

    // fetchDateLocation();

  };

  const handleSelectChangeLocation = (selectedOption) => {
    console.log(selectedOption);
    setFormData(f => ({ ...f, location: selectedOption.value }));

    // fetchDateLocation();

  };


  const chartRef = useRef(null);
  const chartInstance = useRef(null);
  const [selectedWeek, setSelectedWeek] = useState(null);


  if (weeklyDataall) {
    const { weeklyData, dailyDataByWeek } = weeklyDataall;

    useEffect(() => {
      // Move currentData inside useEffect so it's always fresh
      const currentData = selectedWeek && dailyDataByWeek[selectedWeek]
        ? dailyDataByWeek[selectedWeek]
        : weeklyData;

      // Add safety check
      if (!currentData || !currentData.labels) {
        console.warn('Chart data not available');
        return;
      }

      Chart.Chart.register(
        Chart.BarController,
        Chart.BarElement,
        Chart.LinearScale,
        Chart.CategoryScale,
        Chart.Title,
        Chart.Tooltip,
        Chart.Legend
      );

      if (!chartRef.current) return;

      if (chartInstance.current) {
        chartInstance.current.destroy();
      }

      chartInstance.current = new Chart.Chart(chartRef.current, {
        type: 'bar',
        data: {
          labels: currentData.labels,
          datasets: [
            {
              label: 'Receptions Net Weight',
              data: currentData.total_net_weight,
              backgroundColor: '#00008B',
              borderColor: '#00008B',
              borderWidth: 2,
              borderRadius: 6
            },
            {
              label: 'Finished Product',
              data: currentData.finished,
              backgroundColor: '#0070C0',
              borderColor: '#0070C0',
              borderWidth: 2,
              borderRadius: 6
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          interaction: {
            mode: 'index',
            intersect: false
          },
          onClick: (_, elements) => {
            if (!selectedWeek && elements.length) {
              setSelectedWeek(weeklyData.labels[elements[0].index]);
            }
          },

          scales: {
            y: {
              beginAtZero: true,
              title: {
                display: true,
                text: 'Weight (kg)',
                font: {
                  size: 14,
                  weight: 'bold'
                }
              },
              ticks: {
                callback: function (value) {
                  return value.toLocaleString();
                }
              }
            },
            x: {
              title: {
                display: true,
                text: selectedWeek ? 'Daily Data' : 'Weekly Data',
                font: {
                  size: 14,
                  weight: 'bold'
                }
              }
            }
          },
          plugins: {
            legend: {
              display: true,
              position: 'top'
            },
            tooltip: {
              callbacks: {
                label: function (context) {
                  return `${context.dataset.label}: ${context.parsed.y.toLocaleString()} kg`;
                }
              }
            }
          }
        }
      });

      return () => chartInstance.current?.destroy();
    }, [selectedWeek, weeklyData, dailyDataByWeek]); // Add dependencies
  }

  console.log("formData");
  console.log(formData);

  const ShiftDateCell = ({ row }) => (
    <a href={`/production-dasboard-dailyreports/${row.original.shift_date}_${row.original.location}_${row.original.shift}_${formData.product}`}>
      {row.original.shift_date}
    </a>
  );

  // ✅ Add PropTypes validation
  ShiftDateCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        shift_date: PropTypes.string.isRequired,
        location: PropTypes.string,
        shift: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  };

  const ShiftCell = ({ row }) => (
    <a href={`/production-dasboard-dailyreports/${row.original.shift_date}_${row.original.location}_${row.original.shift}_${formData.product}`}>
      {row.original.shift}
    </a>
  );

  // ✅ Add PropTypes validation
  ShiftCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        shift_date: PropTypes.string.isRequired,
        location: PropTypes.string,
        shift: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  };

  const locationCell = ({ row }) => (
    <a href={`/production-dasboard-dailyreports/${row.original.shift_date}_${row.original.location}_${row.original.shift}_${formData.product}`}>
      {row.original.location_name}
    </a>
  );

  // ✅ Add PropTypes validation
  locationCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        shift_date: PropTypes.string.isRequired,
        location: PropTypes.string,
        location_name: PropTypes.string,
        shift: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  };


  const TotalBlWeight = ({ row }) => (
    <div>{Number(row.original.bl_net_weight).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
  );
  TotalBlWeight.propTypes = { row: PropTypes.shape({ original: PropTypes.shape({ bl_net_weight: PropTypes.number }) }) };

  const TotalWeight = ({ row }) => (
    <div>{Number(row.original.quantity_processed).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
  );
  TotalWeight.propTypes = { row: PropTypes.shape({ original: PropTypes.shape({ quantity_processed: PropTypes.number }) }) };

  const TotalWeight2 = ({ row }) => (
    <div>{Number(row.original.grade_a).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
  );
  TotalWeight2.propTypes = { row: PropTypes.shape({ original: PropTypes.shape({ grade_a: PropTypes.number }) }) };

  const TotalWeight3 = ({ row }) => (
    <div>{Number(row.original.grade_b).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
  );
  TotalWeight3.propTypes = { row: PropTypes.shape({ original: PropTypes.shape({ grade_b: PropTypes.number }) }) };

  const TotalWeight4 = ({ row }) => (
    <div>{Number(row.original.puree).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
  );
  TotalWeight4.propTypes = { row: PropTypes.shape({ original: PropTypes.shape({ puree: PropTypes.number }) }) };

  
  const TotalWeight41 = ({ row }) => (
    <div>{Number(row.original.crumble).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
  );
  TotalWeight41.propTypes = { row: PropTypes.shape({ original: PropTypes.shape({ crumble: PropTypes.number }) }) };

  const TotalWeight5 = ({ row }) => (
    <div>{Number(row.original.semi_finished).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} </div>
  );
  TotalWeight5.propTypes = { row: PropTypes.shape({ original: PropTypes.shape({ semi_finished: PropTypes.number }) }) };

  const columnss = [
    {
      header: 'Shift Date',
      accessorFn: (row) => `${row.shift_date} `,
      Cell: ShiftDateCell,
    },
    {
      header: 'Location',
      accessorFn: (row) => `${row.location_name} `,
      Cell: locationCell,
    },
    {
      header: 'Shift',
      accessorFn: (row) => `${row.shift} `,
      Cell: ShiftCell,
    },

    {
      accessorKey: 'bl_net_weight',
      header: 'Total reception ( Bl Net Weight)',
      Cell: TotalBlWeight,
    },
    {
      accessorKey: 'quantity_processed',
      header: 'Total Consumption',
      Cell: TotalWeight,
    },

    {
      accessorKey: 'grade_a',
      header: 'Finished Grade A',
      Cell: TotalWeight2,
    },
    {
      accessorKey: 'grade_b',
      header: 'Finished Grade B',
      Cell: TotalWeight3,
    },
    {
      accessorKey: 'crumble',
      header: 'Finished Crumble',
      Cell: TotalWeight41,
    },
     {
      accessorKey: 'puree',
      header: 'Finished Puree',
      Cell: TotalWeight4,
    },
    {
      accessorKey: 'semi_finished',
      header: 'Semi Finished',
      Cell: TotalWeight5,
    },
  ];


  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">

          <div className="content container-fluid top-dashboardfilter" >

            <div className="row" >
              <div className="col-md-3">

                <label><b>Select The Date Range</b></label><br />
                <DateRangePicker
                  value={value}
                  className="dashboard-daterange"
                  // onChange={setValue}
                  onChange={handleDateChange2}
                  placeholder="Select Date Range"
                  //style={{ width: 300 }}
                  ranges={predefinedRanges}
                  showOneCalendar={false}
                />

              </div>
              <div className="col-md-3">

                <label><b>Select Product</b></label><br />
                <Select
                  options={productnameLists}
                  name="supplier"
                  value={productnameLists.find(option => option.value === formData.product) || null} // Ensure it selects the correct option
                  onChange={(selectedOption) => handleSelectChangeCustomer(selectedOption)}
                />

              </div>
              <div className="col-md-3">

                <label><b>Location</b></label><br />
                <Select
                  options={locationlist}
                  name="location"
                  value={locationlist.length > 0 ? locationlist.find(option => option.value == formData.location) : null}
                  onChange={(selectedOption) => handleSelectChangeLocation(selectedOption)}
                />

              </div>


              <div className="col-md-3">
                <div className="" style={{ float: 'right' }}>
                  <button onClick={downloadpdf} className="btn btn-primary me-1" >
                    Export PDF <i className="fa fa-download" />
                  </button>
                </div>
              </div>

            </div>
          </div>

          <div className="content container-fluid" id="downloadpdf">

            <div className="row" >
              <div className="col-xl-3 col-sm-3 col-12">
                <div className="card dashboard-card-border">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-xl-8 col-sm-8 col-8">
                        <div className="dash-widget-header" style={{ paddingTop: '10px' }}>
                          <div className="dash-count">
                            <h5 className="" style={{ color: 'darkgray', fontWeight: '300' }}>Receptions</h5>
                            <div className="dash-counts" style={{ paddingTop: '5px' }}>
                              <p>{dataBoxes.total_net_weight} (KG)</p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-xl-4 col-sm-4 col-4">
                        <div className="dash-widget-header">
                          <span className="dash-widget-icon bg-site">
                            <i className="fa fa-database	"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-3 col-sm-3 col-12">
                <div className="card dashboard-card-border">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-xl-8 col-sm-8 col-8">
                        <div className="dash-widget-header" style={{ paddingTop: '10px' }}>
                          <div className="dash-count">
                            <h5 className="" style={{ color: 'darkgray', fontWeight: '300' }}>Finished Products</h5>
                            <div className="dash-counts" style={{ paddingTop: '5px' }}>
                              <p>{dataBoxes.production_finished_product} (KG)</p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-xl-4 col-sm-4 col-4">
                        <div className="dash-widget-header">
                          <span className="dash-widget-icon bg-site">
                            <i className="fa fa-balance-scale	"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



              <div className="col-xl-3 col-sm-3 col-12">
                <div className="card dashboard-card-border">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-xl-8 col-sm-8 col-8">
                        <div className="dash-widget-header" style={{ paddingTop: '10px' }}>
                          <div className="dash-count">
                            <h5 className="" style={{ color: 'darkgray', fontWeight: '300' }}>Losses</h5>
                            <div className="dash-counts" style={{ paddingTop: '5px' }}>
                              <p>{0} (KG)</p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-xl-4 col-sm-4 col-4">
                        <div className="dash-widget-header">
                          <span className="dash-widget-icon bg-site">
                            <i className="fa fa-tasks	"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>




            </div>
            <div className="row">



              {/* <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <h5 className="card-title">Daily received / Daily produced </h5>
                  </div>
                  <div className="card-body">
                    <div style={{ overflowX: 'auto', width: '100%' }}>
                      <div style={{ minWidth: '1000px' }}> 
                        <ReactApexChart
                          options={sColStacked_caliber}
                          series={sColStacked_caliber.series}
                          type="bar"
                          height={350}
                        />
                      </div>
                    </div>

                  </div>
                </div>
              </div> */}

              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <h5 className="card-title">Daily received / Daily produced </h5>
                  </div>
                  <div className="card-body">
                    {/* <div style={{ overflowX: 'auto', width: '100%' }}>
                      <div style={{ minWidth: '1000px' }}> 

                        <div className="w-full h-full p-6 bg-white">
                          <div className="mb-4 flex items-center justify-between">
                            <p className="text-2xl font-bold text-gray-800">
                              {selectedWeek ? `Daily Data: ${selectedWeek}` : 'Weekly Production Overview'}
                            </p>
                            {selectedWeek && (
                              <button
                                onClick={() => setSelectedWeek(null)}
                                className="px-4 py-2 bg-blue-600 btn btn-primary rounded-lg hover:bg-blue-700 transition-colors"
                              >
                                ← Back to Weekly View
                              </button>
                            )}
                          </div>

                          <div className="text-sm  mb-4">
                            {!selectedWeek && 'Click on any bar to see daily breakdown'}
                          </div>

                          <div style={{ height: '500px' }}>
                            <canvas ref={chartRef}></canvas>
                          </div>
                        </div>
                      </div>
                    </div>
                     */}
                    <div className="w-full p-6 bg-white">
                      <div className="mb-4 flex items-center justify-between">
                        <p className="text-2xl font-bold text-gray-800">
                          {selectedWeek ? `Daily Data: ${selectedWeek}` : 'Weekly Production Overview'}
                        </p>
                        {selectedWeek && (
                          <button
                            onClick={() => setSelectedWeek(null)}
                            className="px-4 py-2 bg-blue-600 btn btn-primary rounded-lg hover:bg-blue-700 transition-colors"
                          >
                            ← Back to Weekly View
                          </button>
                        )}
                      </div>

                      <div className="text-sm mb-4">
                        {!selectedWeek && 'Click on any bar to see daily breakdown'}
                      </div>

                      {/* Scroll wrapper */}
                      <div style={{ overflowX: 'auto', width: '100%' }}>
                        <div style={{
                          minWidth: `${Math.max(800, (weeklyDataall?.weeklyData?.labels?.length || 10) * 80)}px`,
                          height: '500px',
                          position: 'relative'
                        }}>
                          <canvas ref={chartRef}></canvas>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12 col-sm-12">
                <div className="card">
                  <div className="card-header">
                    <div className="row">
                      <div className="col">
                        <h5 className="card-title"> Top 10 Calculated Daily Reports</h5>
                      </div>
                      <div className="col-auto">
                      </div>
                    </div>
                  </div>
                  <div className="card-body">

                    <div className="table-responsive">
                      <MaterialReactTable
                        columns={columnss}
                        data={dailyreports}
                        enableColumnOrdering
                        enablePinning
                        enablePagination
                        initialState={{ pagination: { pageSize: 10, pageIndex: 0 } }}
                        muiPaginationProps={{
                          rowsPerPageOptions: [10, 50, 100, { label: 'All', value: dailyreports.length }],
                          showFirstButton: true,
                          showLastButton: true,
                        }}
                        paginationDisplayMode="pages"
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* <div className="col-md-12 col-sm-12">
                <div className="card">
                  <div className="card-header">
                    <div className="row">
                      <div className="col">
                        <h5 className="card-title"> Top 10 Calculated Daily Reports</h5>
                      </div>
                      <div className="col-auto">
                      </div>
                    </div>
                  </div>
                  <div className="card-body">


                    <div className="table-responsive">
                      <table className="table table-stripped table-hover">
                        <thead className="thead-light">
                          <tr>
                            <th>Date</th>
                            <th>Product</th>
                            <th>Product Type</th>
                            <th>Location</th>
                            <th>Shift</th>
                            <th>Total consumption</th>
                            <th>Finished product ( KG )</th>
                            <th>Semi Finished product ( KG )</th>

                          </tr>
                        </thead>
                        <tbody>
                          {cusomerbalance.map((item, index) => {


                            return (
                              <tr key={index}>
                                <td>{item.shift_date}</td>
                                <td>{item.product_name}</td>
                                <td>{item.product_type}</td>
                                <td>{item.location_name}</td>
                                <td>{item.shift}</td>
                                <td>{item.sum_quantity_processed}</td>
                                <td>{item.finished.toFixed(2)}</td>
                                <td>{item.semi_finished.toFixed(2)}</td>

                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div> */}



            </div>


          </div>
        </div>
      </div>
    </>
  );
};
export default ProductionDashboard;
